export const debounce = (callback, wait) => {
    let timeoutId = null;
    return () => {
        window.clearTimeout(timeoutId);
        timeoutId = window.setTimeout(() => {
            callback();
        }, wait);
    }
}

export const passParams = (filters ={},isFirst=true) => {
    const filterKeys = Object.keys(filters);
    let filter = ""
    filterKeys.forEach((key) => {
        if (filters[key] != "" && filters[key]) {
            filter += `${filter == "" ? (isFirst ? '?':'&') : '&'}${key}=${filters[key]}`

        }
    })
    return filter
}

export const toPascalCase = (str = " ") =>
    str
        .match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g)
        ?.map((x) => x.charAt(0).toUpperCase() + x.slice(1).toLowerCase())
        .join("");